"use strict";

var A1ENVELOPES = 'A1Envelope';
var BASIC_BOOKLET_WEDDING_PROGRAMS = 'BasicProgram';
var CUSTOM_COMPONENT = 'CustomComponent';
var CUSTOM_SIGNS = 'CustomSign';
var DELXUE_BOOKLET_WEDDING_PROGRAM_COVERS = 'DeluxeProgramCoverPage';
var DELXUE_BOOKLET_WEDDING_PROGRAM_INTERIORS = 'DeluxeProgramInteriorPage';
var ENVELOPE_LINERS = 'EnvelopeLiner';
var EURO_FLAP_ENVELOPE_LINERS = 'EuroFlapEnvelopeLiner';
var FAVOR_TAG = 'FavorTag';
var FLAT_BOOKLET_WEDDING_PROGRAMS = 'FlatProgram';
var FREE_INVITATION_SAMPLES = 'FreeClassicInvitationSample';
var FREE_LETTERPRESS_INVITATION_SAMPLES = 'FreeLetterpressInvitationSample';
var INVITATIONS = 'Invitation';
var INVITATION_ENVELOPES = 'InvitationEnvelope';
var A7ENVELOPES = 'A7Envelope';
var A75ENVELOPES = 'A75Envelope';
var LARGE_ENCLOSURES = 'LargeEnclosure';
var LETTERPRESS_INVITATIONS = 'LetterpressInvitation';
var LETTERPRESS_LARGE_ENCLOSURES = 'LetterpressLargeEnclosure';
var LETTERPRESS_RESPONSE_CARDS = 'LetterpressResponseCard';
var LETTERPRESS_SAVE_THE_DATES = 'LetterpressSaveTheDate';
var LETTERPRESS_SMALL_ENCLOSURES = 'LetterpressSmallEnclosure';
var PAID_INVITATION_SAMPLES = 'PaidClassicInvitationSample';
var PAID_LETTERPRESS_INVITATION_SAMPLES = 'PaidLetterpressInvitationSample';
var PLACE_CARDS = 'PlaceCard';
var RESERVED_SIGNS = 'ReservedSign';
var RESPONSE_CARDS = 'ResponseCard';
var RESPONSE_CARD_ENVELOPES = 'ResponseCardEnvelope';
var SILK_RIBBON_SAMPLES = 'RibbonSample';
var SILK_RIBBON_SPOOLS = 'RibbonSpool';
var SAVE_THE_DATES = 'SaveTheDate';
var SAVE_THE_DATE_ENVELOPES = 'SaveTheDateEnvelope';
var SEATING_CHARTS = 'SeatingChart';
var SMALL_ENCLOSURES = 'SmallEnclosure';
var SQUARE_PROGRAMS = 'SquareProgram';
var TABLE_NUMBERS = 'TableNumber';
var THANK_YOU_CARDS = 'ThankYouCard';
var THANK_YOU_CARD_ENVELOPES = 'ThankYouCardEnvelope';
var THICK_WRAPPERS = 'ThickWrapper';
var VELLUM_JACKETS = 'VellumJacket';
var WAX_SEALS = 'WaxSeal';
var WEDDING_MENUS = 'WeddingMenu';
var LETTERPRESS_WEDDING_MENUS = 'LetterpressWeddingMenu';
var WEDDING_SIGNS = 'WeddingSign';
var WELCOME_SIGNS = 'WelcomeSign';
var WRAPPERS = 'Wrapper';
var ACCESSORIES_THANK_YOU_CARDS = 'AccessoriesThankYouCard';
var COMPONENTS_CARDS = 'ComponentsCard';
var DOUBLE_THICK_EXAMPLE_CARDS = 'DoubleThickExampleCard';
var ENVELOPE_LINER_INSERTS = 'EnvelopeLinerInsert';
var INFORMATION_2018_CARDS = 'Information2018Card';
var INVITATION_THANK_YOU_CARDS = 'InvitationThankYouCard';
var LETTERPRESS_SAMPLE_CARDS = 'LetterpressSampleCard';
var ORDER_TIMELINE_CARDS = 'OrderTimelineCard';
var PACKED_BY_CARDS = 'PackedByCard';
var PHOTOGRAPHY_INSERTS = 'PhotographyInsert';
var RIBBON_INSTRUCTIONS = 'RibbonInstruction';
var RIBBON_SAMPLE_INSTRUCTIONS = 'RibbonSampleInstruction';
var SAVE_THE_DATE_THANK_YOU_CARDS = 'SaveTheDateThankYouCard';
var STANDARD_INSTRUCTIONS = 'StandardInstruction';
var WHY_SHINE_CARDS = 'WhyShineCard';
var CUSTOM_COLOR_CHARTS = 'CustomColorChart';
var COLOR_CHARTS = 'ColorChart';
var COLOR_CHART_LINERS = 'ColorChartLiner';
var SAMPLE_INVITATIONS = 'SampleInvitation';
var SAMPLE_INVITATION_ENVELOPES = 'SampleInvitationEnvelope';
var SAMPLE_ENVELOPE_LINERS = 'SampleEnvelopeLiner';
var SAMPLE_RESPONSE_CARDS = 'SampleResponseCard';
var SAMPLE_RESPONSE_CARD_ENVELOPES = 'SampleResponseCardEnvelope';
var SAMPLE_SMALL_ENCLOSURES = 'SampleSmallEnclosure';
var SAMPLE_LARGE_ENCLOSURES = 'SampleLargeEnclosure';
var SAMPLE_WRAPPERS = 'SampleWrapper';
var SAMPLE_THICK_WRAPPERS = 'SampleThickWrapper';
var SAMPLE_MEDIUM_WRAPPERS = 'SampleMediumWrapper';
var RIBBON_SAMPLE_CARDS = 'RibbonSampleCard';
var LINER_SAMPLES = 'LinerSample';
var WEDDING_PLANNER_BOXES = 'WeddingPlannerBox';
var ANNOUNCEMENTS = 'Announcement';
var MEDIUM_WRAPPERS = 'MediumWrapper';
module.exports = {
  ANNOUNCEMENTS: ANNOUNCEMENTS,
  WEDDING_PLANNER_BOXES: WEDDING_PLANNER_BOXES,
  LINER_SAMPLES: LINER_SAMPLES,
  RIBBON_SAMPLE_CARDS: RIBBON_SAMPLE_CARDS,
  SAMPLE_THICK_WRAPPERS: SAMPLE_THICK_WRAPPERS,
  SAMPLE_WRAPPERS: SAMPLE_WRAPPERS,
  SAMPLE_MEDIUM_WRAPPERS: SAMPLE_MEDIUM_WRAPPERS,
  SAMPLE_LARGE_ENCLOSURES: SAMPLE_LARGE_ENCLOSURES,
  SAMPLE_SMALL_ENCLOSURES: SAMPLE_SMALL_ENCLOSURES,
  SAMPLE_RESPONSE_CARD_ENVELOPES: SAMPLE_RESPONSE_CARD_ENVELOPES,
  SAMPLE_RESPONSE_CARDS: SAMPLE_RESPONSE_CARDS,
  SAMPLE_ENVELOPE_LINERS: SAMPLE_ENVELOPE_LINERS,
  SAMPLE_INVITATION_ENVELOPES: SAMPLE_INVITATION_ENVELOPES,
  SAMPLE_INVITATIONS: SAMPLE_INVITATIONS,
  COLOR_CHARTS: COLOR_CHARTS,
  COLOR_CHART_LINERS: COLOR_CHART_LINERS,
  CUSTOM_COLOR_CHARTS: CUSTOM_COLOR_CHARTS,
  WHY_SHINE_CARDS: WHY_SHINE_CARDS,
  STANDARD_INSTRUCTIONS: STANDARD_INSTRUCTIONS,
  SAVE_THE_DATE_THANK_YOU_CARDS: SAVE_THE_DATE_THANK_YOU_CARDS,
  RIBBON_SAMPLE_INSTRUCTIONS: RIBBON_SAMPLE_INSTRUCTIONS,
  RIBBON_INSTRUCTIONS: RIBBON_INSTRUCTIONS,
  PHOTOGRAPHY_INSERTS: PHOTOGRAPHY_INSERTS,
  PACKED_BY_CARDS: PACKED_BY_CARDS,
  ORDER_TIMELINE_CARDS: ORDER_TIMELINE_CARDS,
  LETTERPRESS_SAMPLE_CARDS: LETTERPRESS_SAMPLE_CARDS,
  INVITATION_THANK_YOU_CARDS: INVITATION_THANK_YOU_CARDS,
  INFORMATION_2018_CARDS: INFORMATION_2018_CARDS,
  ENVELOPE_LINER_INSERTS: ENVELOPE_LINER_INSERTS,
  DOUBLE_THICK_EXAMPLE_CARDS: DOUBLE_THICK_EXAMPLE_CARDS,
  COMPONENTS_CARDS: COMPONENTS_CARDS,
  ACCESSORIES_THANK_YOU_CARDS: ACCESSORIES_THANK_YOU_CARDS,
  A1ENVELOPES: A1ENVELOPES,
  BASIC_BOOKLET_WEDDING_PROGRAMS: BASIC_BOOKLET_WEDDING_PROGRAMS,
  CUSTOM_COMPONENT: CUSTOM_COMPONENT,
  CUSTOM_SIGNS: CUSTOM_SIGNS,
  DELXUE_BOOKLET_WEDDING_PROGRAM_COVERS: DELXUE_BOOKLET_WEDDING_PROGRAM_COVERS,
  DELXUE_BOOKLET_WEDDING_PROGRAM_INTERIORS: DELXUE_BOOKLET_WEDDING_PROGRAM_INTERIORS,
  ENVELOPE_LINERS: ENVELOPE_LINERS,
  EURO_FLAP_ENVELOPE_LINERS: EURO_FLAP_ENVELOPE_LINERS,
  FAVOR_TAG: FAVOR_TAG,
  FLAT_BOOKLET_WEDDING_PROGRAMS: FLAT_BOOKLET_WEDDING_PROGRAMS,
  FREE_INVITATION_SAMPLES: FREE_INVITATION_SAMPLES,
  FREE_LETTERPRESS_INVITATION_SAMPLES: FREE_LETTERPRESS_INVITATION_SAMPLES,
  INVITATIONS: INVITATIONS,
  INVITATION_ENVELOPES: INVITATION_ENVELOPES,
  A7ENVELOPES: A7ENVELOPES,
  A75ENVELOPES: A75ENVELOPES,
  LARGE_ENCLOSURES: LARGE_ENCLOSURES,
  LETTERPRESS_INVITATIONS: LETTERPRESS_INVITATIONS,
  LETTERPRESS_LARGE_ENCLOSURES: LETTERPRESS_LARGE_ENCLOSURES,
  LETTERPRESS_RESPONSE_CARDS: LETTERPRESS_RESPONSE_CARDS,
  LETTERPRESS_SAVE_THE_DATES: LETTERPRESS_SAVE_THE_DATES,
  LETTERPRESS_SMALL_ENCLOSURES: LETTERPRESS_SMALL_ENCLOSURES,
  PAID_INVITATION_SAMPLES: PAID_INVITATION_SAMPLES,
  PAID_LETTERPRESS_INVITATION_SAMPLES: PAID_LETTERPRESS_INVITATION_SAMPLES,
  PLACE_CARDS: PLACE_CARDS,
  RESERVED_SIGNS: RESERVED_SIGNS,
  RESPONSE_CARDS: RESPONSE_CARDS,
  RESPONSE_CARD_ENVELOPES: RESPONSE_CARD_ENVELOPES,
  SILK_RIBBON_SAMPLES: SILK_RIBBON_SAMPLES,
  SILK_RIBBON_SPOOLS: SILK_RIBBON_SPOOLS,
  SAVE_THE_DATES: SAVE_THE_DATES,
  SAVE_THE_DATE_ENVELOPES: SAVE_THE_DATE_ENVELOPES,
  SEATING_CHARTS: SEATING_CHARTS,
  SMALL_ENCLOSURES: SMALL_ENCLOSURES,
  SQUARE_PROGRAMS: SQUARE_PROGRAMS,
  TABLE_NUMBERS: TABLE_NUMBERS,
  THANK_YOU_CARDS: THANK_YOU_CARDS,
  THANK_YOU_CARD_ENVELOPES: THANK_YOU_CARD_ENVELOPES,
  THICK_WRAPPERS: THICK_WRAPPERS,
  VELLUM_JACKETS: VELLUM_JACKETS,
  WAX_SEALS: WAX_SEALS,
  WEDDING_MENUS: WEDDING_MENUS,
  WEDDING_SIGNS: WEDDING_SIGNS,
  WELCOME_SIGNS: WELCOME_SIGNS,
  WRAPPERS: WRAPPERS,
  MEDIUM_WRAPPERS: MEDIUM_WRAPPERS,
  LETTERPRESS_WEDDING_MENUS: LETTERPRESS_WEDDING_MENUS
};